module.exports = {
    serverUrl: process.env.REACT_APP_HEATING_APP_SERVER_URL
};